export default function Nav() {
  return (
    <header className="nav">
      <div className="nav-inner">
        <a className="brand" href="#top">
          <img src="/icon.png" alt="" className="brand-mark" width={28} height={28} />
          <span>
            Viridian <span className="brand-name">Cloud Partners</span>
          </span>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact" className="btn btn-primary btn-small">
            Get in touch
          </a>
        </nav>
      </div>
    </header>
  );
}
